import React, { useState, useEffect } from 'react';
import {
    Box, Typography, ThemeProvider
} from '@mui/material';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ARROW, BASEURL } from "../../constants/Common";
import getTheme from '../../theme/theme';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import BasicTable, { Column } from '../../components/table';

interface History {
    organization_id: number;
    plan_name: string;
    start_date: Date;
    end_date: Date;
}

const SubscriptionHistoryPage: React.FC = () => {
    const [history, setHistory] = useState<History[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const orgid = localStorage.getItem('orgid');

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await axios.get(`${BASEURL}/subscription-history/${orgid}/`, {
                    headers: { Accept: 'application/json' },
                });
                setHistory(response.data.subscription_history);
            } catch (error) {
                console.error('Failed to fetch subscription history', error);
            } finally {
                setLoading(false);
            }
        };
        fetchHistory();
    }, [orgid]);

    // Sort the history array by end_date in descending order
    const sortedHistory = history.sort((a, b) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime());

    const columns: Column[] = [
        { id: 'plan_name', label: 'Plan Name', align: 'left' },
        { id: 'start_date', label: 'Start Date', align: 'left' },
        { id: 'end_date', label: 'End Date', align: 'left' },
        { id: 'duration', label: 'Duration', align: 'left' },
    ];

    const rows = sortedHistory.map((item) => ({
        plan_name: item.plan_name,
        start_date: item.start_date,
        end_date: item.end_date,
        duration: '1 Year',
    }));

    return (
        <ThemeProvider theme={getTheme()}>
            <Box
                sx={{
                    pt: 5,
                    pb: 10,
                    px: 2,
                    mt: '-80px',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'left', marginTop: 0 }}>
                    <Typography variant="h6" gutterBottom>
                        <Link to={'/subscriptions'}>Subscriptions</Link>
                        {ARROW}
                        History
                    </Typography>
                </Box>
                <Box>
                    <BasicTable columns={columns} rows={rows} />
                </Box>
            </Box>
            <FloatingButton />
        </ThemeProvider>
    );
};

export default SubscriptionHistoryPage;